import * as yup from 'yup';

export const observationSchema = yup.object({
    observation: yup.string().label('observation'),
});

export type observationSchemaType = yup.InferType<typeof observationSchema>
